import React from "react";
import ClampLines from "react-clamp-lines";
import PencilIcon from "../../../../../components/Images/PencilIcon";
import { menuItemObj } from "../../../../../components/PrivatePage";
import { Box, Text } from "../../../../../designSystem";
import { convertUrlToHttps } from "../../../../../lib/utils";
import {
    SingleBookDetail,
    BookDetailTopSection,
    ThumbnailDiv,
    Thumbnail,
    Details,
    Description,
    ArtistDetails,
    ProfileImageDiv,
    ProfileImage,
    MobileDescription,
    StyledAuthorIcon,
    EditBookDiv,
    EditBookSpan,
    EditButton,
    EditNovelButtonDiv,
  } from "../../styles";

const BookDetail = (props) => {
    const isMobile = window.screen.width < 600;
    const { book, onUserClick } = props
    return (
    <>
        <SingleBookDetail key={book.book_id}>
            <BookDetailTopSection>
                <ThumbnailDiv>
                    {book.image_url && (
                    <Thumbnail src={convertUrlToHttps(book.image_url)} />
                    )}
                </ThumbnailDiv>
                <Details>
                    <Box mb="4px">
                    <Text variant="title">{book.book_title}</Text>
                    </Box>
                    {book.category_obj.topic_name && (
                    <Box mb="4px">
                        <Text variant="subtext">
                        {book.category_obj.topic_name}
                        </Text>
                    </Box>
                    )}
                    {!isMobile && (
                    <Description>
                        <ClampLines
                        lines={2}
                        text={
                            book.description || "No description available"
                        }
                        id={book.book_id}
                        />
                    </Description>
                    )}
                    {!isMobile && book.author_info && (
                    <>
                        <ArtistDetails
                        onClick={() =>
                            onUserClick(book.author_info.author_id)
                        }
                        >
                        <ProfileImageDiv>
                            <ProfileImage
                            src={convertUrlToHttps(book.author_info.image_url)}
                            />
                            <StyledAuthorIcon />
                        </ProfileImageDiv>
                        <Text variant="caption" ml="8px">
                            {book.author_info.fullname}
                        </Text>
                        </ArtistDetails>
                    </>
                    )}
                </Details>
                <EditNovelButtonDiv>
                    <EditBookDiv isMobile={isMobile}>
                        <EditButton
                            to={`${menuItemObj.novels}/edit-novel-details/${book.book_id}`}
                        >
                            <PencilIcon />
                            {!isMobile &&<EditBookSpan>Edit {book?.is_novel === 2 ? 'Series' : 'Novel'}</EditBookSpan>}
                            {isMobile &&<EditBookSpan>Edit</EditBookSpan>}
                        </EditButton>
                    </EditBookDiv>
                </EditNovelButtonDiv>

                {/* <VellipContainer ref={bookOptionsRef}>
                    <VellipIcon
                    onClick={() => toggleShowBookOptions(!isBookOptionsShown)}
                    />
                    <BookOptionsBox show={isBookOptionsShown}>
                    <EditBookDiv>
                        <EditButton
                        to={`${menuItemObj.novels}/edit-novel-details/${book.book_id}`}
                        >
                        <PencilIcon />
                        <EditBookSpan>Edit Novel</EditBookSpan>
                        </EditButton>
                    </EditBookDiv>
                    </BookOptionsBox>
                </VellipContainer> */}
            </BookDetailTopSection>

            {isMobile && (
            <MobileDescription>
                <ClampLines
                    lines={2}
                    text={book.description || "No description available"}
                    id={book.book_id}
                />
            </MobileDescription>
            )}

            {isMobile && book.author_info && (
            <>
                <ArtistDetails
                onClick={() =>
                    onUserClick(book.author_info.author_id)
                }
                >
                <ProfileImageDiv>
                    <ProfileImage src={book.author_info.image_url} />
                    <StyledAuthorIcon />
                </ProfileImageDiv>
                {/* <ArtistName> */}
                {/* {book.author_info.fullname} */}
                <Text variant="caption" ml="8px">
                    {book.author_info.fullname}
                </Text>
                {/* </ArtistName> */}
                </ArtistDetails>
            </>
            )}
        </SingleBookDetail>
    </>
    )
}

export default BookDetail